// extracted by mini-css-extract-plugin
export default {"container":"AwardCEModal_container__kZnW+"};